<template>
    <div>
        <h1 class="mb-5">{{ $t('progLang.progLang') }}</h1>
        <div class="row justify-content-center">
            <div v-for="language in languages" :key="language.id" class="progLang col-md-3 col-sm-6 mb-5 unlink">
                <ProgrammingLanguageDetails :title="language.title" :desc="language.desc" :id="language.id"
                    :preview="language.preview" :percentage="language.percentage" />
            </div>
            <div class="progLang col-md-3 col-sm-6 mb-5">
                <b-button v-b-modal:[`progLang-more`] key="progLang-more" class="unlink">
                    <img src="@/assets/more.png" class="img mb-3" />
                    <h4 class="pt-0 ">{{ $t('progLang.moreLang') }}</h4>
                    <p class="pt-2">{{ $t('progLang.clickForMore') }}</p>
                </b-button>
            </div>
        </div>

        <b-modal :id="`progLang-more`" body-bg-variant="dark" bodyTextVariant='light' size="l" centered scrollable
            hide-footer hide-header>
            <div class="container">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('progLang.moreLang') }}</h5>
                    <button type="button" class="btn-close btn-close-white" data-dismiss="modal" aria-label="Close"
                        @click="$bvModal.hide(`progLang-more`)">
                    </button>
                </div>
                <div class="modal-body">
                    <div v-for="language in moreLanguages" :key="language.id">
                        <h3><img :src="imgUrl(language.img)" class="logo" /> {{ $t(language.title) }}</h3>
                        <p>{{ $t(language.text) }}</p>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ProgrammingLanguageDetails from './ProgrammingLanguageDetails.vue';
var images = require.context('@/assets', false, /^\.\//)

export default {
    name: "ProgrammingLanguages",
    components: { ProgrammingLanguageDetails },
    data() {
        return {

            "languages": [
                {
                    "id": "1",
                    "title": "progLang.titleCSharp",
                    "preview": "progLang.prevSeeSharp",
                    "desc": [
                        { "headline": "companies.eDVSchool", "text": "progLang.SeeSharpSchool" },
                        { "headline": "companies.magna", "text": "progLang.SeeSharpMagna" },
                        { "headline": "companies.num42", "text": "progLang.number42SeeSharp" },
                        { "headline": "companies.waveCampus", "text": "progLang.waveCampus" }
                    ],
                    "percentage": 95
                },
                {
                    "id": "2",
                    "title": "progLang.titleDartFlutterFirebase",
                    "preview": "progLang.prevApp",
                    "desc": [
                        { "headline": "progLang.flutterCourse", "text": "progLang.dartFlutterFirebase" },
                        { "headline": "projects.achivementRideWithMe.title", "text": "progLang.rideWithMe" },
                        { "headline": "projects.deepDiveApp.title", "text": "progLang.deepDiveApp" },
                        { "headline": "projects.artnerApp.title", "text": "progLang.artnerApp" }
                    ],
                    "percentage": 85
                },
                {
                    "id": "3",
                    "title": "progLang.titleTypeScript",
                    "preview": "progLang.prevApp",
                    "desc": [
                        { "headline": "progLang.firebaseCloudFunctions", "text": "progLang.typeScript" }
                    ],
                    "percentage": 85
                },
                {
                    "id": "4",
                    "title": "progLang.titleAngular",
                    "preview": "progLang.prevWeb",
                    "desc": [
                        { "headline": "progLang.udemyCourse", "text": "progLang.angular" }
                    ],
                    "percentage": 75
                },
                {
                    "id": "5",
                    "title": "progLang.titleSymfonyPHP",
                    "preview": "progLang.prevSymfony",
                    "desc": [
                        { "headline": "progLang.companyEnvenance", "text": "progLang.symfony" }
                    ],
                    "percentage": 70
                },
                {
                    "id": "6",
                    "title": "progLang.titleJava",
                    "preview": "progLang.prevJava",
                    "desc": [
                        { "headline": "progLang.edvSchool", "text": "progLang.Java" },
                        { "headline": "progLang.wineWizard", "text": "progLang.wineWizardDesc" }
                    ],
                    "percentage": 60
                },
                {
                    "id": "7",
                    "title": "progLang.titleWeb",
                    "preview": "progLang.prevWeb",
                    "desc": [
                        { "text": "progLang.web" }
                    ],
                    "percentage": 70
                }
            ],
            "moreLanguages": [
                { "id": "1", "title": "progLang.titlePython", "text": "progLang.python", "img": "python.png" },
                { "id": "2", "title": "progLang.titleVue", "text": "progLang.vue", "img": "vue.png" },
                { "id": "3", "title": "progLang.titleCAndCpp", "text": "progLang.c", "img": "cPlusPlus.png" },
                { "id": "4", "title": "progLang.titleMQTT", "text": "progLang.mqtt", "img": "mqtt.png" },
                { "id": "5", "title": "progLang.titlePostgreSQL", "text": "progLang.postgreSql", "img": "postgresql.png" },
                { "id": "6", "title": "progLang.titleMariaDB", "text": "progLang.mariaDB", "img": "mariadb.png" },
                { "id": "7", "title": "progLang.titleFirestore", "text": "progLang.firestore", "img": "firestore.png" },
                { "id": "8", "title": "progLang.titleOracleDB", "text": "progLang.oracleDB", "img": "oracle.png" },
                { "id": "9", "title": "progLang.titleAssembler", "text": "progLang.assembler", "img": "nasm.png" },
                { "id": "10", "title": "progLang.titleEspressoGherkin", "text": "progLang.espresso", "img": "kotlin.png" }
            ]

        }
    },
    methods: {
        imgUrl: function (path) {
            return images("./" + path)
        }
    }
}
</script>

<style lang="sass" scoped>
    .unlink
        background-color: inherit !important
        border: none
        &:hover
            color: #0a58ca !important
   
    .img
        text-align: center
        width: 100%
        object-fit: scale-down
        max-height: 62px
    
    .logo
        height: 20px

</style>